export const SET_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC =
  'SET_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC';
export const setInfoWindowsSocioeconomicDemographic = (payload) => ({
  type: SET_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const CLOSE_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC =
  'CLOSE_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC';
export const closeInfoWindowsSocioeconomicDemographic = () => ({
  type: CLOSE_INFOWINDOWS_SOCIOECONOMIC_DEMOGRAPHIC,
});

export const ADD_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC =
  'ADD_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC';
export const addGeocodeSocioeconomicDemographic = (payload) => ({
  type: ADD_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const RESET_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC =
  'RESET_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC';
export const resetGeocodeSocioeconomicDemographic = () => ({
  type: RESET_GEOCODE_SOCIOECONOMIC_DEMOGRAPHIC,
});

export const UPDATE_MODAL_DATA_SOCIOECONOMIC_DEMOGRAPHIC =
  'UPDATE_MODAL_DATA_SOCIOECONOMIC_DEMOGRAPHIC';
export const updateModalDataSocioeconomicDemographic = (payload) => ({
  type: UPDATE_MODAL_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const UPDATE_MODAL_CHARTS_SOCIOECONOMIC_DEMOGRAPHIC =
  'UPDATE_MODAL_CHARTS_SOCIOECONOMIC_DEMOGRAPHIC';
export const updateModalChartsSocioeconomicDemographic = (payload) => ({
  type: UPDATE_MODAL_CHARTS_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const UPDATE_MODAL_TABLES_SOCIOECONOMIC_DEMOGRAPHIC =
  'UPDATE_MODAL_TABLES_SOCIOECONOMIC_DEMOGRAPHIC';
export const updateModalTablesSocioeconomicDemographic = (payload) => ({
  type: UPDATE_MODAL_TABLES_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const UPDATE_ERROR_FETCH_DATA_SOCIOECONOMIC_DEMOGRAPHIC =
  'UPDATE_ERROR_FETCH_DATA_SOCIOECONOMIC_DEMOGRAPHIC';
export const updateErrorFetchDataSocioeconomicDemographic = (payload) => ({
  type: UPDATE_ERROR_FETCH_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const CLEAN_POLYGONS_ON_MAP_SOCIOECONOMIC_DEMOGRAPHIC =
  'CLEAN_POLYGONS_ON_MAP_SOCIOECONOMIC_DEMOGRAPHIC';
export const setShouldCleanPolygonsOnMap = (payload) => ({
  type: CLEAN_POLYGONS_ON_MAP_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const UPDATE_CHARTS_DATA_SOCIOECONOMIC_DEMOGRAPHIC =
  'UPDATE_CHARTS_DATA_SOCIOECONOMIC_DEMOGRAPHIC';
export const updateChartsDataSocioeconomicDemographic = (payload) => ({
  type: UPDATE_CHARTS_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const UPDATE_TABLES_DATA_SOCIOECONOMIC_DEMOGRAPHIC =
  'UPDATE_TABLES_DATA_SOCIOECONOMIC_DEMOGRAPHIC';
export const updateTablesDataSocioeconomicDemographic = (payload) => ({
  type: UPDATE_TABLES_DATA_SOCIOECONOMIC_DEMOGRAPHIC,
  payload,
});

export const UPDATE_ERROR_FETCH_DATA = 'UPDATE_ERROR_FETCH_DATA';
export const updateErrorFetchData = (payload) => ({
  type: UPDATE_ERROR_FETCH_DATA,
  payload,
});

export const RESET_ERROR_FETCH_DATA = 'RESET_ERROR_FETCH_DATA';
export const resetErrorFetchData = () => ({
  type: RESET_ERROR_FETCH_DATA,
});
